import { Icon, InlineMessage, Typography } from "@saviynt/design-system";
import { QRCodeSVG } from "qrcode.react";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { MfaCodeInput } from "../MfaCodeInput";

interface SetupMfaStepProps {
  qrCode: string;
  mfaCode: string[];
  onMfaCodeChange: (code: string[]) => void;
  onMfaComplete: (code: string) => void;
  error?: string;
}

export default function SetupMfaStep({
  qrCode,
  mfaCode,
  onMfaCodeChange,
  onMfaComplete,
  error,
}: SetupMfaStepProps) {
  const intl = useIntl();
  const [hasError, setHasError] = useState(false);

  const handleCodeChange = (code: string[]) => {
    setHasError(false);
    onMfaCodeChange(code);
  };

  const handleComplete = (code: string) => {
    setHasError(true);
    onMfaComplete(code);
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-3 items-center">
        <div className="p-4 bg-white rounded-lg">
          <QRCodeSVG value={qrCode} size={192} level="M" />
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <Typography kind="body3" className="text-center">
          <FormattedMessage
            id="Ym1Y8s"
            defaultMessage="Next, enter the verification code displayed on the app:"
          />
        </Typography>
        <MfaCodeInput
          value={mfaCode}
          onChange={handleCodeChange}
          onComplete={handleComplete}
          hasError={hasError && !!error}
        />
        {hasError && error && (
          <InlineMessage
            text={intl.formatMessage({
              id: "zlhJLn",
              defaultMessage: "Incorrect passcode",
              description: "MFA incorrect passcode error",
            })}
            colorTheme="critical"
            size="small"
            leftIcon={<Icon kind="AlertCriticalFilled" />}
          />
        )}
      </div>
    </div>
  );
}
